angular.module('cfn').factory('cfnGridFiltering', [
  'propertySupport',
  '$filter',
  function(propertySupport, $filter) {
    var service = {};

    service.init = function(scope, element, attrs) {
      var serviceInstance = {};

      serviceInstance.specialFiltersForTypes = {
        day: function(filter, modelRow, col) {
          var ok = true;
          if (modelRow[col]) {
            var d = new Date(filter.date);
            d.setHours(0, 0, 0, 0);
            var md = new Date(modelRow[col]);
            md.setHours(0, 0, 0, 0);
            if (!(md.getTime() === d.getTime())) {
              ok = false;
            }
          } else {
            ok = false;
          }
          return ok;
        },
        timeFrame: function(filter, modelRow, col) {
          var ok = true;
          if (modelRow[col]) {
            var d = new Date(filter.startDate);
            d.setHours(0, 0, 0, 0);
            var d2 = new Date(filter.endDate);
            d2.setHours(0, 0, 0, 0);
            var md = new Date(modelRow[col]);
            md.setHours(0, 0, 0, 0);
            if (
              !(md.getTime() >= d.getTime() && md.getTime() <= d2.getTime())
            ) {
              ok = false;
            }
          } else ok = false;
          return ok;
        }
      };

      serviceInstance.defaultFilterPreprocessors = {
        double: function(value, column) {
          return $filter('number')(value, column.typeparam);
        },
        bool: function(value, column) {
          if (!value) {
            return 'false';
          } else {
            return value;
          }
        }
      };

      serviceInstance.angularFilterByColumnType = {
        date: function(column) {
          return "date:'mediumDate'";
        },
        timepicker: function(column) {
          return "date:'shortTime'";
        },
        datetime: function(column) {
          return "date:'short'";
        },
        timeduration: function(column) {
          return 'timeDuration';
        },
        double: function(column) {
          if (!column.typeparam) {
            column.typeparam = 2;
          }
          return 'number:' + column.typeparam;
        }
      };
      serviceInstance.applyFilters = function(list) {
        var sortedModel = [];

        if (list)
          $.each(list, function(i, modelRow) {
            var ok = true,
              val;

            // special filters
            $.each(scope.view.filters, function(col_, filter) {
              if (filter !== undefined && filter !== null && filter !== '') {
                // Special filter
                var col = col_;
                var column = scope.columnsByName[col_] || {};

                if (column.searchMapping) {
                  col = column.searchMapping;
                }

                if (column.filtertypeOverride === 'boolean-showall') {
                  val = propertySupport.deepGet(modelRow, col);
                  ok = !!filter || val !== filter;
                }

                // TODO: merge - dynamic columns dont have a function hasCustomFilterFn - added a check if hasCustomFilterFn is existing
                if (column.hasCustomFilterFn && column.hasCustomFilterFn()) {
                  ok = ok && column.customFilterFn()(filter, modelRow, col);
                } else if (filter.type) {
                  // .type is e.g. set by date-time popup
                  if (serviceInstance.specialFiltersForTypes[filter.type]) {
                    if (
                      !serviceInstance.specialFiltersForTypes[filter.type](
                        filter,
                        modelRow,
                        col
                      )
                    ) {
                      ok = false;
                    }
                  }
                } else if (filter.length > 0) {
                  // all other text based filters
                  val = propertySupport.deepGet(modelRow, col);

                  column = scope.columnsByName[col];

                  // apply default filter preprocessors to ensure that the types can be correctly filtered
                  for (var defaultFilter in serviceInstance.defaultFilterPreprocessors) {
                    // indexof is used because column names are not always equal. this is a bit hacky and might need to be changed in future
                    if (
                      column &&
                      column.type !== null &&
                      column.type.toLowerCase().indexOf(defaultFilter) !== -1
                    ) {
                      val = serviceInstance.defaultFilterPreprocessors[
                        defaultFilter
                      ](val, column);
                    }
                  }

                  if (val !== undefined && val !== null) {
                    val = val + ''; // convert to string
                    if (column && column.filter) {
                      // special filters for columns
                      val = $filter(scope.columnsByName[col].filter)(val);
                    } else if (column && column.replaceByEnum) {
                      //TODO: this is pretty hacky. we might want to move this out of this file because it is very specific.
                      // special filter handling for replaceByEnum - because we have a parameter.
                      val = $filter('replaceByEnum')(val, column.replaceByEnum);
                    }
                    if (
                      !(val.toLowerCase().indexOf(filter.toLowerCase()) !== -1)
                    ) {
                      ok = false;
                    }
                  } else {
                    ok = false;
                  }
                }
              }
            });
            if (ok) {
              sortedModel.push(modelRow);
            }
          });
        return sortedModel;
      };
      return serviceInstance;
    };

    return service;
  }
]);
